import z from 'zod';

import { ELanguages } from '@enums/languages.enum';
import { EProviderSpecialty } from '@enums/provider.enum';
import { paginationSchema } from '@schemas/pagination.schema';

export const getAllProvidersSchema = paginationSchema.extend({
  languages: z.enum(ELanguages).array().optional(),
  businessLineIds: z.uuid().array().optional(),
  postcodes: z.string().array().optional(),
  specialties: z.enum(EProviderSpecialty).array().optional(),
});

export type GetAllProvidersParams = z.infer<typeof getAllProvidersSchema>;
